import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = {
  // Coaches
  getCoaches: (location) => axios.get(`${API}/coaches`, { params: { location } }),
  getCoach: (id) => axios.get(`${API}/coaches/${id}`),
  
  // Programs
  getPrograms: (params) => axios.get(`${API}/programs`, { params }),
  getProgram: (id) => axios.get(`${API}/programs/${id}`),
  
  // Locations
  getLocations: () => axios.get(`${API}/locations`),
  getLocation: (id) => axios.get(`${API}/locations/${id}`),
  
  // News
  getNews: (params) => axios.get(`${API}/news`, { params }),
  getNewsArticle: (id) => axios.get(`${API}/news/${id}`),
  
  // Events
  getEvents: (params) => axios.get(`${API}/events`, { params }),
  
  // Testimonials
  getTestimonials: () => axios.get(`${API}/testimonials`),
  
  // Newsletter
  subscribeNewsletter: (email) => axios.post(`${API}/newsletter`, { email }),
  
  // Contact
  submitContact: (data) => axios.post(`${API}/contact`, data),
  
  // Community Submissions
  submitCommunity: (data) => axios.post(`${API}/community-submissions`, data),
  
  // Search
  search: (q) => axios.get(`${API}/search`, { params: { q } }),
  
  // Training Resources
  getTrainingResources: (category) => axios.get(`${API}/training`, { params: { category } }),
  
  // Director
  getDirector: () => axios.get(`${API}/director`),
  
  // College Consulting
  getCollegeConsulting: () => axios.get(`${API}/college-consulting`),
  
  // Seed
  seedDatabase: () => axios.post(`${API}/seed`),
};

export default api;
